module.exports = __webpack_public_path__ + "06_bob_grey.d003409b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/06_bob_grey.png
// module id = a/c8
// module chunks = 0